/** @jsx jsx */
import React, { useRef, useMemo } from "react";
import { jsx, Box, Flex, Heading } from "theme-ui";
import ContentfulRichText from "../../shared/ContentfulRichText";
import Icon from "../../shared/Icon";
import "./faqsection.css";

const Accordion = ({ faq,  onToggle, active  }) => {
  const { question, answer } = faq;
  const contentEl = useRef();

  const accordionIcon = useMemo(() => {
    const arrow = active ? "up-chevron" : "down-chevron";
    return (
      <Box>
        <Flex className="icon-wrapper" >
          <Icon icon={arrow} sx={{
            color: '#FFF',
            fontSize: ['20px', '28px']
          }} />
        </Flex>
      </Box>
    );

  }, [active]);

  return (
    <li className={`accordion-item ${active ? "active" : ""}`} sx={{marginBottom: "20px"}}>
      <Flex
        sx={{ justifyContent: "space-between", mb: "10px" }}
        className="button"
        onClick={onToggle}
      >
        <Heading as="h6" sx={{fontWeight: 600, maxWidth: '90%'}}>
          {question}
        </Heading>
        <Box className="control">{accordionIcon}</Box>
      </Flex>

      <Box
        ref={contentEl}
        className="answer-wrapper"
        style={ active
          ? { height: contentEl.current.scrollHeight}
          : { height: "0px" }}
      >
        {answer &&
          <ContentfulRichText richText={answer} textfontSize="18px"  />
        }
      </Box>
      <Box className="accordion-closed" />
    </li>
  );
};

export default Accordion;

